export class OrganizationTag {
  public id: string;
  public name: string;

  constructor(data: Partial<OrganizationTag> = {}) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
  }

  public static createFromApi(data: any = {}): OrganizationTag {
    return new OrganizationTag({
      id: data?.id ?? '',
      name: data?.name ?? data?.title ?? '',
    });
  }

  public processForApi(): Record<string, any> {
    return {
      id: this.id,
      title: this.name,
    };
  }
}
